import { render, staticRenderFns } from "./ItemNews.vue?vue&type=template&id=324839fc&scoped=true"
import script from "./ItemNews.vue?vue&type=script&lang=js"
export * from "./ItemNews.vue?vue&type=script&lang=js"
import style0 from "./ItemNews.vue?vue&type=style&index=0&id=324839fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324839fc",
  null
  
)

export default component.exports